import { render, staticRenderFns } from "./RsaAdiProtocolliEditComponent.vue?vue&type=template&id=e320ca98"
import script from "./RsaAdiProtocolliEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaAdiProtocolliEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports